module.exports = __webpack_public_path__ + "static/media/LUPIN_F1.f82e5e6c.txt";